import axios from "axios";
import { APP_VERSION, ENVIRONMENT } from "config_environment";
import { LocalStorageKey } from "utils";

// Use production.ugenie.io for production, dashboard.ugenie.io for development
const PRODUCTION_API_URL = "https://production.ugenie.io/api/v1";
const DASHBOARD_API_URL = "https://dashboard.ugenie.io/api/v1";

const getBaseUrl = () => {
	if (ENVIRONMENT === "production") return PRODUCTION_API_URL;
	if (ENVIRONMENT === "development") return DASHBOARD_API_URL;
	return DASHBOARD_API_URL; // fallback to dashboard
};

const joinedAxios = axios.create({
	baseURL: getBaseUrl(),
	headers: {
		"Content-Type": "application/json",
		"X-UHUBS-PLATFORM": "web",
		"X-UHUBS-PLATFORM-VERSION": APP_VERSION,
	},
});

// Add auth token interceptor
joinedAxios.interceptors.request.use((config) => {
	const token = localStorage.getItem(LocalStorageKey);
	if (token && config.headers) {
		config.headers["Authorization"] = token;
	}
	return config;
});

export const communitiesJoined = {
	get: (payload?: { q?: string; page?: number; slug?: string }) =>
		joinedAxios.get("/communities/joined", { params: payload }),
};
